import {
  BEGIN_AJAX_CALL,
  END_AJAX_CALL,
  GET_TOTAL_PLATFORM_DETAILS,
  GET_MEDIA_LIST_DETAILS,
  GET_DATACONFIG_LIST_DATA,
  GET_INFOMATERY_DETAILS,
} from "../../constants/actionType";
import {
  getDataConfigApi,
  postDataConfigApi,
  getDataConfigv1Api,
  getInfoDetailsApi,
} from "../../api/dataConfig";

export const getDataConfigDeatilsAction =
  ({ tenantId, authToken, userId, params = {} }) =>
  async (dispatch) => {
    let configData = {};
    try {
      dispatch({
        type: BEGIN_AJAX_CALL,
        showSpinner: true,
      });

      configData = await getDataConfigApi({
        tenantId,
        authToken,
        userId,
        params,
      });
      if (Object.keys(params).length == 2) {
        if (
          Object.values(params).every((value) =>
            ["all", "platform"].includes(value)
          )
        ) {
          dispatch({
            type: GET_TOTAL_PLATFORM_DETAILS,
            platformListDetails: configData.response ? configData.response : [],
          });
        }
      }
      return configData;
    } catch (err) {
    } finally {
      dispatch({
        type: END_AJAX_CALL,
        showSpinner: false,
      });
    }
  };

export const getDataConfigDeatilsv1Action =
  ({ tenantId, authToken, userId, params = {} }) =>
  async (dispatch) => {
    let configData = {};
    try {
      dispatch({
        type: BEGIN_AJAX_CALL,
        showSpinner: true,
      });

      configData = await getDataConfigv1Api({
        tenantId,
        authToken,
        userId,
        params,
      });
      if (Object.keys(params).length == 2) {
        if (
          Object.values(params).every((value) =>
            ["all", "platform"].includes(value)
          )
        ) {
          dispatch({
            type: GET_TOTAL_PLATFORM_DETAILS,
            platformListDetails: configData.response
              ? configData.response.filter(
                  (platform) => platform.value.toLowerCase() !== "beki"
                )
              : [],
          });
        }
      }
      return configData;
    } catch (err) {
    } finally {
      dispatch({
        type: END_AJAX_CALL,
        showSpinner: false,
      });
    }
  };

export const getInfomateryDeatilsAction =
  ({ tenantId, authToken, userId, params = {}, showSpinner = false }) =>
  async (dispatch) => {
    let infoData = {};
    try {
      if (showSpinner) {
        dispatch({
          type: BEGIN_AJAX_CALL,
          showSpinner: true,
        });
      }

      infoData = await getInfoDetailsApi({
        tenantId,
        authToken,
        userId,
        params,
      });

      if (infoData.responseObj) {
        dispatch({
          type: GET_INFOMATERY_DETAILS,
          infomateryDetails: infoData.responseObj,
        });
      }

      return infoData;
    } catch (err) {
    } finally {
      if (showSpinner) {
        dispatch({
          type: END_AJAX_CALL,
          showSpinner: false,
        });
      }
    }
  };

export const postDataConfigDetailsAction =
  ({ tenantId, authToken, userId, params, payload }) =>
  async (dispatch) => {
    let configData = {};
    try {
      dispatch({
        type: BEGIN_AJAX_CALL,
        showSpinner: true,
      });
      configData = await postDataConfigApi({
        tenantId,
        authToken,
        userId,
        params,
        payload,
      });
      if (Object.keys(params).length == 1 && Object.keys(payload).length == 1) {
        if (
          Object.values(params).every((value) => ["all"].includes(value)) &&
          Object.values(payload).every((value) =>
            ["Media_Type"].includes(value)
          )
        ) {
          const mediaListData = configData.response
            .map((item) => {
              return {
                ...item,
                list: item.list
                  .filter((listItem) => listItem.isActive)
                  .map((listItem) => {
                    return {
                      key: listItem.id,
                      value: listItem.displayName ? listItem.displayName : listItem.name,
                    };
                  }),
              };
            })
            .filter((itemList) => itemList.isActive);
          dispatch({
            type: GET_MEDIA_LIST_DETAILS,
            mediaListData: mediaListData ? mediaListData : [],
          });
        }
      }
      return configData;
    } catch (err) {
    } finally {
      dispatch({
        type: END_AJAX_CALL,
        showSpinner: false,
      });
    }
  };

export const getDataConfigAllListAction =
  ({ tenantId, authToken, userId, params = {} }) =>
  async (dispatch) => {
    let dataConfigListData = {};
    try {
      dispatch({
        type: BEGIN_AJAX_CALL,
        showSpinner: true,
      });
      dataConfigListData = await getDataConfigApi({
        tenantId,
        authToken,
        userId,
        params,
      });
      dispatch({
        type: GET_DATACONFIG_LIST_DATA,
        dataConfigListData,
      });
      return dataConfigListData;
    } catch (err) {
    } finally {
      dispatch({
        type: END_AJAX_CALL,
        showSpinner: false,
      });
    }
  };
